<template>
  <main class="configure-deal">
    <!-- Page Header -->
    <header class="configure-deal__header">
      <button class="configure-deal__back" @click="$router.back()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="configure-deal__header-content">
        <h1 class="configure-deal__title">Deal Configuration</h1>
        <p class="configure-deal__subtitle">Configure your private raise settings and details</p>
      </div>
    </header>

    <!-- Configuration Card -->
    <div class="configure-deal__card">
      <!-- Tab Navigation -->
      <nav class="configure-deal__nav">
        <button
          class="configure-deal__tab"
          :class="{ 'configure-deal__tab--active': currentSection === 'AssetDetails' }"
          @click="currentSection = 'AssetDetails'"
        >
          <span class="configure-deal__tab-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.27002 6.96002L12 12.01L20.73 6.96002" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          Asset Details
        </button>
        <button
          class="configure-deal__tab"
          :class="{ 'configure-deal__tab--active': currentSection === 'SpvDetails' }"
          @click="currentSection = 'SpvDetails'"
        >
          <span class="configure-deal__tab-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          SPV Details
        </button>
        <button
          class="configure-deal__tab"
          :class="{ 'configure-deal__tab--active': currentSection === 'DealConfiguration' }"
          @click="currentSection = 'DealConfiguration'"
        >
          <span class="configure-deal__tab-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
              <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          Deal Settings
        </button>
      </nav>

      <!-- Tab Content -->
      <div class="configure-deal__content">
        <keep-alive>
          <component
            :spvId="token && token.spv ? token.spv : ''"
            :is="currentSection"
            :tokenId="token ? token.token : ''"
            @show-member-form="showMemberForm = true"
          ></component>
        </keep-alive>
      </div>
    </div>
  </main>
</template>

<script>
import AssetDetails from "@/layout/asset/CreateAssetInfo.vue";
import { mapActions, mapGetters } from "vuex";
import DealConfiguration from "./DealRequest";
import SpvDetails from "./spv/Index";
export default {
  name: "ConfigureDeal",
  data() {
    return {
      currentSection: "AssetDetails",
    };
  },
  components: {
    DealConfiguration,
    AssetDetails,
    SpvDetails,
  },
  computed: {
    ...mapGetters("TokenModule", ["token"]),
  },
  watch: {
    token(val) {
      this.getAsset(val.asset._id || val.asset);
    },
  },
  created() {
    this.getTokenRequest(this.$route.params.id);
  },
  methods: {
    ...mapActions("assetModule", ["getAsset"]),
    ...mapActions("TokenModule", ["getTokenRequest"]),
  },
};
</script>

<style lang="scss" scoped>
.configure-deal {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 0;
  
  // Page Header
  &__header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 32px;
  }
  
  &__back {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    color: #64748B;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:hover {
      background: #F8FAFC;
      color: #0F172A;
      border-color: #CBD5E1;
    }
  }
  
  &__header-content {
    flex: 1;
  }
  
  &__title {
    font-size: 24px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 4px 0;
  }
  
  &__subtitle {
    font-size: 14px;
    color: #64748B;
    margin: 0;
  }
  
  // Configuration Card
  &__card {
    background: #ffffff;
    border: 1px solid #E2E8F0;
    border-radius: 16px;
    overflow: hidden;
  }
  
  // Tab Navigation
  &__nav {
    display: flex;
    gap: 4px;
    padding: 16px 24px 0;
    background: #F8FAFC;
    border-bottom: 1px solid #E2E8F0;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  &__tab {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 20px;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    margin-bottom: -1px;
    
    &:hover {
      color: #0F172A;
      background: rgba(77, 132, 255, 0.04);
    }
    
    &--active {
      color: #4D84FF;
      font-weight: 500;
      border-bottom-color: #4D84FF;
      background: #ffffff;
      border-radius: 8px 8px 0 0;
      
      .configure-deal__tab-icon {
        color: #4D84FF;
      }
    }
  }
  
  &__tab-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94A3B8;
    transition: color 0.2s ease;
  }
  
  // Tab Content
  &__content {
    padding: 32px;
    min-height: 400px;
  }
}

// Responsive
@media (max-width: 768px) {
  .configure-deal {
    &__header {
      flex-direction: column;
      gap: 12px;
    }
    
    &__back {
      width: 36px;
      height: 36px;
    }
    
    &__title {
      font-size: 20px;
    }
    
    &__nav {
      padding: 12px 16px 0;
    }
    
    &__tab {
      padding: 12px 16px;
      font-size: 13px;
    }
    
    &__content {
      padding: 20px 16px;
    }
  }
}
</style>
